import {Route, Routes} from "react-router-dom";
import {RouteHelper, RouteInfo} from "../route/RouteHelper";
import "./ContainerStyleSheet.scss"
import Header from "../component/Header/Header";
import Profile from "../pages/profile/Profile";
import Dashboard from "../pages/dashboard/Dashboard";
import React from 'react';
import ManagersList from "../pages/managersList/ManagersList";
import {ManagerDetail} from "../pages/managerDetail/ManagerDetail";
import {ManagerAccessLevelList} from "../pages/managerAccessLevelList/ManagerAccessLevelList";
import ManagerAccessLevelDetails from "../pages/managerAccessLevelDetails/ManagerAccessLevelDetails";
import TagsList from "../pages/tagsList/TagsList";
import MagazineWriters from "../pages/magazineWriters/MagazineWriters";
import MagazineWriterDetail from "../pages/magazineWriters/MagazineWriterDetail";
import NotFound from "../pages/notFound/NotFound";
import NotAccess from "../pages/notAccess/NotAccess";
import PaymentGatewaysList from "../pages/paymentGatewaysList/PaymentGatewaysList";
import PaymentGatewayInformation from "../component/paymentGateway/paymentGatewayInformation/PaymentGatewayInformation";
import {TransactionsList} from "../pages/transactions/TransactionsList";
import Users from "../pages/users/Users";
import UserInformation from "../pages/userInfromation/UserInformation";
import {TransactionDetail} from "../pages/transactions/TransactionDetail";
import Union from "../pages/union/Union";
import Groups from "../pages/groups/Groups";
import GroupDetail from "../pages/groups/groupDetail/GroupDetail";
import CashInfo from "../pages/cashInfo/CashInfo";
import GroupReports from "../pages/groups/GroupReports";
import AccountsList from "../pages/accounts/AccountsList";
import AccountDetail from "../pages/accounts/detail/AccountDetail";
import CashTransactions from "../pages/cashTransactions/CashTransactions";
import CostAndRevenueCategory from "../pages/categoryManager/CostAndRevenueCategory";
import Feedback from "../pages/feedback/Feedback";
import FeedbackInfo from "../pages/feedback/FeedbackInfo";
import Election from "../pages/election/Election";
import AccountTransactions from "../pages/accountTransactions/AccountTransactions";
import AccountNewTransactions from "../pages/accountTransactions/AccountNewTransactions";
import CashTransactionDetails from "../pages/cashTransactions/CashTransactionDetails";
import AccountUpdateTransactions from "../pages/accountTransactions/AccountUpdateTransactions";
import AccountCheckout from "../pages/accountTransactions/AccountCheckout";
import LoansList from "../pages/loan/LoansList";
import LoanDetail from "../pages/loan/detail/LoanDetail";
import LoanCreateNew from "../pages/loan/LoanCreateNew";
import OtherPayments from "../pages/otherPayments/OtherPayments";
import OtherPaymentDetails from "../serverService/otherPayment/OtherPaymentDetails";
import ElectionDetails from "../pages/election/ElectionDetails";
import LoanInstallments from "../pages/loanInstallments/LoanInstallments";
import LoanPayInstallments from "../pages/loanPayInstallments/LoanPayInstallments";
import LoanRequests from "../pages/loanRequests/LoanRequests";
import LoanRequestDetail from "../pages/loanRequests/detail/LoanRequestDetail";
import SystemLogsList from "../pages/logs/SystemLogsList";
import SystemLogsDetail from "../pages/logs/SystemLogsDetail";


const Container = () => {

    return (
        <section
            className={"basePageContainer"}>
            <div className={"baseHeaderContainer"}>
                <Header/>
            </div>

            <section className={`basePageContentContainer`}>
                <Routes>
                    <Route path={RouteInfo.Profile.url} element={<Profile/>}/>


                    <Route path={RouteInfo.Managers.url} element={<ManagersList/>}/>
                    <Route path={RouteInfo.ManagersDetail.url} element={<ManagerDetail/>}/>
                    <Route path={RouteInfo.ManagersAccess.url} element={<ManagerAccessLevelList/>}/>
                    <Route path={RouteInfo.ManagersAccessDetail.url} element={<ManagerAccessLevelDetails/>}/>


                    <Route path={RouteInfo.Dashboard.url} element={<Dashboard/>}/>

                    <Route path={RouteHelper.Union.url} element={<Union/>}/>

                    <Route path={RouteHelper.CashInfo.url} element={<CashInfo/>}/>

                    <Route path={RouteHelper.MagazineWriters.url} element={<MagazineWriters/>}/>
                    <Route path={RouteHelper.MagazineWriterDetail.url} element={<MagazineWriterDetail/>}/>


                    <Route path={RouteHelper.PaymentGatewaysList.url} element={<PaymentGatewaysList/>}/>
                    <Route path={RouteHelper.PaymentGatewaysInformation.url} element={<PaymentGatewayInformation/>}/>


                    <Route path={RouteHelper.TransactionsList.url} element={<TransactionsList/>}/>
                    <Route path={RouteHelper.TransactionDetail.url} element={<TransactionDetail/>}/>

                    <Route path={RouteHelper.CashTransactions.url} element={<CashTransactions/>}/>
                    <Route path={RouteHelper.CashTransactionsDetails.url} element={<CashTransactionDetails/>}/>
                    <Route path={RouteHelper.CostAndRevenueCategory.url} element={<CostAndRevenueCategory/>}/>

                    <Route path={RouteHelper.TagList.url} element={<TagsList/>}/>

                    <Route path={RouteHelper.FeedBack.url} element={<Feedback/>}/>
                    <Route path={RouteHelper.FeetBackInfo.url} element={<FeedbackInfo/>}/>

                    <Route path={RouteHelper.Election.url} element={<Election/>}/>
                    <Route path={RouteHelper.ElectionDetails.url} element={<ElectionDetails/>}/>


                    <Route path={RouteHelper.OtherPayments.url} element={<OtherPayments/>}/>
                    <Route path={RouteHelper.OtherPaymentsDetails.url} element={<OtherPaymentDetails/>}/>

                    <Route path={RouteHelper.Users.url} element={<Users/>}/>
                    <Route path={RouteHelper.UserInformation.url} element={<UserInformation/>}/>

                    <Route path={RouteHelper.GroupsList.url} element={<Groups/>}/>
                    <Route path={RouteHelper.GroupsDetail.url} element={<GroupDetail/>}/>
                    <Route path={RouteHelper.GroupsReport.url} element={<GroupReports/>}/>

                    <Route path={RouteHelper.AccountsList.url} element={<AccountsList/>}/>
                    <Route path={RouteHelper.AccountsDetail.url} element={<AccountDetail/>}/>
                    <Route path={RouteHelper.AccountsTransactionsList.url} element={<AccountTransactions/>}/>
                    <Route path={RouteHelper.AccountsNewTransaction.url} element={<AccountNewTransactions/>}/>
                    <Route path={RouteHelper.AccountsUpdateTransaction.url} element={<AccountUpdateTransactions/>}/>
                    <Route path={RouteHelper.AccountsCheckout.url} element={<AccountCheckout/>}/>


                    <Route path={RouteHelper.LoansList.url} element={<LoansList/>}/>
                    <Route path={RouteHelper.LoanDetail.url} element={<LoanDetail/>}/>
                    <Route path={RouteHelper.LoansCreateNewItem.url} element={<LoanCreateNew/>}/>

                    <Route path={RouteHelper.InstallmentsList.url} element={<LoanInstallments/>}/>
                    <Route path={RouteHelper.PayInstallments.url} element={<LoanPayInstallments/>}/>
                    <Route path={RouteHelper.LoansRequests.url} element={<LoanRequests/>}/>
                    <Route path={RouteHelper.LoansRequestsDetail.url} element={<LoanRequestDetail/>}/>


                    <Route path={RouteHelper.LogsList.url} element={<SystemLogsList/>}/>
                    <Route path={RouteHelper.LogsDetail.url} element={<SystemLogsDetail/>}/>


                    <Route path="/403" element={<NotAccess/>}/>
                    <Route path={'/'} element={<Dashboard/>}/>
                    <Route path="/*" element={<NotFound/>}/>
                </Routes>
            </section>
            {/*<section className={css`*/}
            {/*  width: 100%;*/}
            {/*  padding: .5rem;*/}
            {/*  display: flex;*/}
            {/*  align-items: center;*/}
            {/*  justify-content: center;*/}
            {/*`}>*/}
            {/*    <RaikoCopyRight/>*/}
            {/*</section>*/}

        </section>
    )
}
export default Container